let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4K9UI")).then(() => parcelRequire('2KsIL'));